import { Stack } from "@mui/material";
import { styled } from "@mui/material/styles";

const PREFIX = "PermanentInput";
export const classes = {
  root: `${PREFIX}-root`,
  formControl: `${PREFIX}-formControl`,
  switch: `${PREFIX}-switch`,
  stack: `${PREFIX}-stack`,
};

export const PermanentInputStack = styled(Stack)(({ theme }) => ({
  [`&.${classes.root}`]: {
    flexWrap: "nowrap",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "flex-start",
    [`& .${classes.formControl}`]: {
      display: "flex",
      justifyContent: "space-between",
      flexBasis: "50%",
      paddingRight: theme.spacing(1),
    },
    [`& .${classes.switch}`]: {
      color: theme.palette.primary,
    },
  },
}));
